import { environment } from '../../environment';

export const getApiEndPointUrl = (...paths: string[]): string => `${environment.apiUrl}${paths.join('/')}`;
export const getResponseApiEndPointUrl = (...paths: string[]): string =>
	`${process.env.REACT_APP_API_URL}${paths.join('/')}`;
